export enum MeasurementDevices {
  V_WEIR = 'v_weir',
  FREE_FLOW = 'free_flow_circular_culvert',
  GRAVITATIONAL_CIRCULAR = 'gravitational_circular_culvert',
  MANNINGS_PAIR = 'mannings_pair',
}
